<!-- Hero Section -->
<section class="relative flex flex-col items-center gap-6">
  <div
    class="absolute h-full w-full bg-[radial-gradient(#d1d5db_1px,transparent_1px)] [background-size:16px_16px] [mask-image:radial-gradient(ellipse_50%_50%_at_50%_50%,#000_85%,transparent_100%)]"
  ></div>
  <div class="z-10 flex flex-col items-center gap-14">
    <h1 class="text-center text-4xl font-bold leading-relaxed md:text-5xl">
      @defer {
        Become a
        <span
          [roughNotation]="{
            animate: true,
            animationDelay: 500,
            strokeWidth: 3,
            iterations: 4,
            type: 'underline',
            color: 'var(--tui-background-accent-2)',
            padding: 2,
          }"
          >Capawesome Partner</span
        ><br />and Grow Your Business
      } @placeholder {
        Become a Capawesome Partner<br />and Grow Your Business
      }
    </h1>
    <p class="w-full text-balance text-center text-xl leading-snug md:w-3/4">
      <span class="hidden md:block"
        >Join our partner ecosystem and unlock new opportunities with priority
        support, co-marketing benefits, and exclusive resources to deliver
        exceptional mobile solutions to your clients using Capawesome</span
      >
      <span class="md:hidden"
        >Join our partner ecosystem with priority support and exclusive
        resources for exceptional mobile solutions</span
      >
    </p>
    <div class="flex flex-col space-y-4 sm:flex-row sm:space-x-4 sm:space-y-0">
      <a
        size="l"
        tuiButton
        type="button"
        [href]="'mailto:' + emailSales"
        data-umami-event="partners-contact-sales"
      >
        Contact Sales
      </a>
      <a
        appearance="secondary"
        iconEnd="@tui.external-link"
        size="l"
        tuiButton
        type="button"
        [href]="bookingUrl"
        target="_blank"
        data-umami-event="partners-book-meeting"
      >
        Book a Meeting
      </a>
    </div>
  </div>
</section>
